import { OfferAcceptConfirmModal } from 'src/app/main/merchant-offers/DefaultView/OfferAcceptConfirmModal';
import { createModalsManager } from './modalManager';
import { NorthAcceptOptionsDialog } from 'src/app/main/merchant-offers/north/NorthAcceptOptionsModal';
import { NorthApplicationLoadingModal } from 'src/app/main/merchant-offers/north/NorthApplicationLoadingModal';
import { NorthCallModal } from 'src/app/main/merchant-offers/north/NorthCallDialog';
import { NorthOnboardingDialogContent } from 'src/app/main/merchant-offers/north/NorthOnboardingDialog';
import { KurvFormModal } from 'src/app/main/merchant-offers/KurvForm/KurvFormDialog';
import { KurvCompleteAccountDialog } from 'src/app/main/merchant-offers/KurvForm/KurvCompleteAccountDialog';
import { OfferCompletedMessageDialog } from 'src/app/main/merchant-offers/DefaultView/OfferCompletedMessageDialog';
import { NorthOfferCompletedMessageDialog } from 'src/app/main/merchant-offers/north/NorthOfferCompletedMessageDialog';
import { Merchant0420CapabilitiesModal } from './Merchant0420CapabilitiesModal';
import { MerchantPeptidesModal } from './MerchantPeptidesModal';

export const modalsManger = createModalsManager(() => ({
  modals: {
    OfferAcceptConfirmModal: {
      component: OfferAcceptConfirmModal,
    },
    NorthAcceptOptionsDialog: {
      component: NorthAcceptOptionsDialog,
    },
    NorthApplicationLoadingModal: {
      component: NorthApplicationLoadingModal,
    },
    NorthCallModal: {
      component: NorthCallModal,
    },
    NorthOnboardingDialogContent: {
      component: NorthOnboardingDialogContent,
    },
    KurvFormModal: {
      component: KurvFormModal,
    },
    KurvCompleteAccountDialog: {
      component: KurvCompleteAccountDialog,
    },
    OfferCompletedMessageDialog: {
      component: OfferCompletedMessageDialog,
    },
    NorthOfferCompletedMessageDialog: {
      component: NorthOfferCompletedMessageDialog,
    },
    Merchant0420CapabilitiesModal: {
      component: Merchant0420CapabilitiesModal,
    },
    MerchantPeptidesModal: {
      component: MerchantPeptidesModal,
    },
  },
}));
